import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import CustomButton from "../controls/CustomButton";
import "../../assets/css/PatientModal.css";
import { ImWarning } from "react-icons/im";
import moment from "moment";

function LockedPrescriptionPopup({ response, onClose }) {
  const [show, setShow] = useState(true);
  const handleClose = () => {
    setShow(false);
    onClose(false);
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" centered>
      <div className="clinical_modal">
        <Modal.Header>
          <ImWarning size={12} color={"red"} />
          <Modal.Title>Prescription in progress</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="progressmodal_body">
            <p>
              {response?.viewedBy} viewed this prescription at{" "}
              {moment(response?.viewedTime).format("DD/MM/YYYY hh:mm A")}. Do
              you want to continue?
            </p>
          </div>
        </Modal.Body>
        <div className="progressmodal_footer">
          <CustomButton label="No" action={() => onClose(false)} />
          <CustomButton label="Yes" action={() => onClose(true)} />
        </div>
      </div>
    </Modal>
  );
}

export default LockedPrescriptionPopup;
